import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import { swSettings } from "app/common/services/swSettings";

export type MaxMinDate = {
    monthlyFrom: Dayjs;
    monthlyTo: Dayjs;
    weeklyFrom: Dayjs;
    weeklyTo: Dayjs;
};

export const getMinMaxDate = (): MaxMinDate => {
    const config = swSettings.current;

    const minDate = dayjs(config.startDate);
    const maxDate = dayjs(config.endDate);
    const minWeeklyDate = dayjs(config.dailyStartDate);
    const maxWeeklyDate = dayjs(config.dailyEndDate);
    const sundayIndex = 0;
    const weeklyDate = dayjs(maxWeeklyDate);
    const currentMaxWeeklyDay = weeklyDate.day();

    return {
        monthlyFrom: minDate,
        monthlyTo: maxDate,
        weeklyFrom: minWeeklyDate,
        weeklyTo: currentMaxWeeklyDay === sundayIndex ? maxWeeklyDate : weeklyDate.subtract(currentMaxWeeklyDay, "day"), // Adjust to the nearest Sunday if necessary
    };
};
